/* ==========================================
   文件: assets/custom-bundles.js
   描述: 独立附加商品包交互逻辑
========================================== */
if (typeof jQuery !== 'undefined') {
    $(document).ready(function() {
      
      // // 1. 监听视觉化色块的点击事件
      // $(document).on('click', '.bundle-swatch-btn', function() {
      //   var $btn = $(this);
      //   var $itemContainer = $btn.closest('.product_info_bundles_item');
      //   var $swatchWrapper = $btn.closest('.bundle-swatch-wrapper');
        
      //   $swatchWrapper.find('.bundle-swatch-btn').removeClass('is-active');
      //   $btn.addClass('is-active');
      //   $swatchWrapper.find('.bundle-swatch-value').text($btn.data('variant-title'));
      //   $itemContainer.find('.product_info_bundles_item_price').text($btn.data('variant-price'));
      //   $itemContainer.removeClass('product_info_bundles_item_act');
  
      //   var newImageSrc = $btn.data('variant-image');
      //   if (newImageSrc) {
      //     var $imageEl = $itemContainer.find('.product_info_bundles_item_images img');
      //     $imageEl.css('opacity', '0.5'); 
      //     setTimeout(function() {
      //       $imageEl.attr('src', newImageSrc);
      //       $imageEl.css('opacity', '1');
      //     }, 100); 
      //   }
      // });
      // 1. 监听视觉化色块的点击事件
    $(document).on('click', '.bundle-swatch-btn', function() {
      var $btn = $(this);
      var $itemContainer = $btn.closest('.product_info_bundles_item');
      var $swatchWrapper = $btn.closest('.bundle-swatch-wrapper');
      
      $swatchWrapper.find('.bundle-swatch-btn').removeClass('is-active');
      $btn.addClass('is-active');
      
      // 更新属性文字和价格
      var variantTitle = $btn.data('variant-title');
      $swatchWrapper.find('.bundle-swatch-value').text(variantTitle);
      $itemContainer.find('.product_info_bundles_item_price').text($btn.data('variant-price'));
      $itemContainer.removeClass('product_info_bundles_item_act');

      // 联动切换左侧的配件产品图
      var newImageSrc = $btn.data('variant-image');
      if (newImageSrc) {
        var $imageEl = $itemContainer.find('.product_info_bundles_item_images img');
        $imageEl.css('opacity', '0.5'); 
        setTimeout(function() {
          $imageEl.attr('src', newImageSrc);
          $imageEl.css('opacity', '1');
        }, 100); 
      }

     // 🎯 联动切换主产品画廊图片 (双模兼容：V2 Swiper + 旧版原生 Impact)
     var isSyncEnabled = $itemContainer.closest('.product_info_bundles_op_b2').data('gallery-sync');
     if (isSyncEnabled && variantTitle) {
        var searchStr = variantTitle.toLowerCase().replace(/\s+/g, '_'); // Glossy Black -> glossy_black
        var fallbackStr = variantTitle.toLowerCase().replace(/\s+/g, '-'); // 兼容用横杠命名的图片
        
        // 【模式 1】：检测到新版 V2 Swiper 画廊
        if (window.pdpMainSwiper) {
          var $gallerySlides = $('.main-swiper .swiper-slide');
          var matchedIndex = -1;
          $gallerySlides.each(function() {
            var src = $(this).attr('data-media-src') || "";
            if (src.includes(searchStr) || src.includes(fallbackStr)) {
              matchedIndex = $(this).data('index');
              return false;
            }
          });
          if (matchedIndex !== -1) {
            window.pdpMainSwiper.slideTo(matchedIndex);
          }
        } 
        // 【模式 2】：适配旧版原生 Impact 画廊
        else {
          var $nativeThumbnails = $('.product-gallery__thumbnail');
          if ($nativeThumbnails.length > 0) {
            $nativeThumbnails.each(function() {
              var src = $(this).attr('data-media-src') || "";
              if (src.includes(searchStr) || src.includes(fallbackStr)) {
                // 直接模拟点击原生的底部小图，Impact 的原生 JS 会自动帮你滑动大图！
                $(this).click(); 
                return false;
              }
            });
          }
        }
      }
    });
  
      // 2. 点击加购/取消按钮
      $(document).on('click', '.product_info_bundles_item_add2', function(e) {
        e.preventDefault();
        var $btn = $(this);
        var $currentParent = $btn.closest('.product_info_bundles_item');
        var $activeSwatch = $currentParent.find('.bundle-swatch-btn.is-active');
        var targetVariantId = $activeSwatch.length > 0 ? String($activeSwatch.data('variant-id')) : String($btn.attr("data-default-id"));
        
        $btn.css('pointer-events', 'none');
        
        if ($currentParent.hasClass("product_info_bundles_item_act")) {
          // 取消加购逻辑
          $.ajax({
            type: 'GET', url: window.Shopify.routes.root + 'cart.js', dataType: 'json',
            success: function(cart) {
              var currentItem = cart.items.find(item => String(item.variant_id) === targetVariantId || String(item.id) === targetVariantId);
              var newQty = currentItem && currentItem.quantity > 0 ? currentItem.quantity - 1 : 0;
              $.ajax({
                type: 'POST', url: window.Shopify.routes.root + 'cart/change.js',
                data: JSON.stringify({ id: targetVariantId, quantity: newQty }),
                dataType: 'json', contentType: 'application/json',
                success: function() {
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                    if (typeof cartDrawer.open === 'function') { cartDrawer.open(); } 
                    else if (typeof cartDrawer.show === 'function') { cartDrawer.show(); } 
                    else { cartDrawer.setAttribute('open', ''); }
                  }
                  $currentParent.removeClass("product_info_bundles_item_act");
                  $btn.css('pointer-events', 'auto');
                },
                error: function() { $btn.css('pointer-events', 'auto'); }
              });
            },
            error: function() { $btn.css('pointer-events', 'auto'); }
          });
        } else {
          // 加购逻辑
          $.ajax({
            type: 'POST', url: window.Shopify.routes.root + 'cart/add.js',
            data: JSON.stringify({ 'items': [{ 'id': targetVariantId, 'quantity': 1 }] }),
            dataType: 'json', contentType: 'application/json',
            success: function() {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                if (typeof cartDrawer.open === 'function') { cartDrawer.open(); } 
                else if (typeof cartDrawer.show === 'function') { cartDrawer.show(); } 
                else { cartDrawer.setAttribute('open', ''); }
              } else {
                const cartIcon = document.querySelector('a[href="/cart"], a[href="' + window.Shopify.routes.root + 'cart"]');
                if (cartIcon) { cartIcon.click(); } else { window.location.href = window.Shopify.routes.root + 'cart'; }
              }
              $currentParent.addClass("product_info_bundles_item_act");
              $btn.css('pointer-events', 'auto');
            },
            error: function(err) {
              alert('Failed to add item to cart.');
              $btn.css('pointer-events', 'auto');
            }
          });
        }
      });
    });
  }